import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type SubscriptionStatus = 'ACTIVE' | 'TRIAL' | 'SUSPENDED' | 'CANCELLED';
type SubscriptionTier = 'FREE' | 'STANDARD' | 'PREMIUM' | 'ENTERPRISE';

interface StatusBadgeProps {
  status: SubscriptionStatus | string | null | undefined;
  className?: string;
}

interface TierBadgeProps {
  tier: SubscriptionTier | string | null | undefined;
  className?: string;
}

const statusConfig: Record<SubscriptionStatus, { label: string; className: string }> = {
  ACTIVE: { label: 'Active', className: 'bg-green-100 text-green-800 hover:bg-green-100' },
  TRIAL: { label: 'Trial', className: 'bg-blue-100 text-blue-800 hover:bg-blue-100' },
  SUSPENDED: { label: 'Suspended', className: 'bg-red-100 text-red-800 hover:bg-red-100' },
  CANCELLED: { label: 'Cancelled', className: 'bg-gray-100 text-gray-800 hover:bg-gray-100' },
};

const tierConfig: Record<SubscriptionTier, { label: string; className: string }> = {
  FREE: { label: 'Free', className: 'bg-gray-100 text-gray-700 hover:bg-gray-100' },
  STANDARD: { label: 'Standard', className: 'bg-blue-100 text-blue-700 hover:bg-blue-100' },
  PREMIUM: { label: 'Premium', className: 'bg-purple-100 text-purple-700 hover:bg-purple-100' },
  ENTERPRISE: { label: 'Enterprise', className: 'bg-amber-100 text-amber-700 hover:bg-amber-100' },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const key = typeof status === 'string' ? status : '';
  const config = statusConfig[key as SubscriptionStatus] ?? {
    label: key || 'Unknown',
    className: 'bg-gray-100 text-gray-800 hover:bg-gray-100',
  };
  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}

export function TierBadge({ tier, className }: TierBadgeProps) {
  const key = typeof tier === 'string' ? tier : '';
  const config = tierConfig[key as SubscriptionTier] ?? {
    label: key || 'Unknown',
    className: 'bg-gray-100 text-gray-700 hover:bg-gray-100',
  };
  return (
    <Badge variant="outline" className={cn(config.className, className)}>
      {config.label}
    </Badge>
  );
}
